import React, { useEffect } from 'react';
import { Monitor, X } from 'lucide-react';
import { GlowIconTile } from './Shinobi';

const MobileNotice = ({ onClose }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{
        background: 'rgba(15, 23, 42, 0.45)',
        backdropFilter: 'blur(6px)',
      }}
    >
      <div
        className="relative rounded-2xl w-full max-w-md p-6 text-center bg-white"
        style={{
          border: '1px solid #e2e8f0',
          boxShadow: '0 20px 50px rgba(15, 23, 42, 0.15)',
        }}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex justify-center mb-4">
          <GlowIconTile icon={Monitor} accent="purple" size="lg" />
        </div>

        <h2 className="text-lg font-bold text-slate-900 tracking-tight mb-2">
          Built for desktop
        </h2>
        <p className="text-sm text-slate-500 leading-relaxed mb-6">
          Wasabi Shinobi is designed for bigger screens. You can still browse on
          mobile, but for scans, reports, and deeper work, switch to desktop when
          you can.
        </p>

        <button
          type="button"
          onClick={onClose}
          className="w-full px-6 py-3 rounded-lg text-sm font-bold tracking-wide transition-all"
          style={{
            background: '#48b94c',
            color: '#ffffff',
            boxShadow: '0 1px 2px rgba(15, 23, 42, 0.08)',
          }}
        >
          Got it, continue →
        </button>
      </div>
    </div>
  );
};

export default MobileNotice;
